export default __webpack_public_path__ + "static/media/step - 9.d47a0315.jpeg";